//
// Copyright (c) 2011-2017 by Curalate, Inc.
//

/* eslint new-cap: ["error", { "capIsNewExceptions": ["Event"] }] */

(function() {
  const curalate = angular.module('curalate');

  curalate.component('searchFilterSocialSearchBar', {
    template: require('@legacy-components/filters/search-filter-social-search-bar.html'),
    bindings: {
      placeholderText: '@',
      includeStateFilter: '<',
      trackingCategory: '@',
      autocompleteCallback: '&',
    },
    require: {
      searchFilter: '^searchFilter',
    },
    controllerAs: '$socialSearch',
    controller: [
      '$scope',
      '$timeout',
      'ContentFilterTypes',
      'SocialSearchBarService',
      function(
                $scope,
                $timeout,
                ContentFilterTypes,
                SocialSearchBarService,
            ) {
        const self = this;

        $scope.model = {
          searchTerm: null,
          loading: false,
          currentRequest: null,
        };

        const addFilter = function(filterObj) {
          const alias = SocialSearchBarService.generatePrefixedString(filterObj);
          const aliasKey = filterObj.value;
          filterObj.aliasKey = aliasKey;
          self.searchFilter.addValue(filterObj);
          self.searchFilter.registerFilterOptionAlias(aliasKey, alias);
          $timeout(() => {
            $scope.$broadcast('twitter-typeahead:reset');
          }, 0);
        };

        $scope.model.typeaheadConfig = {
          events: {
            enterKeyed($event, obj) {
              if (!_.isUndefined(obj) && !_.isNull(obj)) {
                addFilter(obj);
              }
            },
            focus() {
                            // Twitter typeahead doesn't give us access to trigger the dropdown's getData event
                            // However, it calls getData on a keyup event, so...
                            // Create a fake keyup event to trigger this built in behavior.
              const typeaheadElem = this;
              const e = angular.element.Event('keydown.tt');
              e.which = 38;
              typeaheadElem.trigger(e);
            },
          },
          context: {
            addFilter,
          },
          setKeys: ['tags', 'users'],
          templateSets: {
            pre: {
              empty: { html: '<div ng-show="isEmpty" class="empty-set"><em>No matches found</em></div>' },
            },
            tags: {
              header: {
                html:
                                    '<h6 ng-show="!isEmpty" class="subhead">' +
                                        '{{ (!query) ? \'Top Hashtags\' : \'Matching Hashtags\' }}' +
                                    '</h6>',
              },
              suggestion: { html: require('@partials/social-search-tag.html') },
            },
            users: {
              header: {
                html:
                                    '<h6 ng-show="!isEmpty" class="subhead" ng-class="{\'has-prev\': !prevEmpty}">' +
                                        '{{ (!query) ? \'Top Usernames\' : \'Matching Usernames\' }}' +
                                    '</h6>',
              },
              suggestion: { html: require('@partials/social-search-user.html') },
            },
          },
          getData: _.debounce((query, defer) => {
            $scope.model.loading = true;
            if ($scope.model.currentRequest) {
              $scope.model.currentRequest.abort();
            }

            $scope.model.currentRequest = self.autocompleteCallback({ query });
            $scope.model.currentRequest.then((results) => {
              if (results) {
                defer.resolve({
                  tags: _(results.hashtags).map((tag) => { return _(tag).extend({ type: ContentFilterTypes.HASHTAG }); }),
                  users: _(results.usernames).map((user) => { return _(user).extend({ type: ContentFilterTypes.USERNAME }); }),
                });
              }
            }).finally(() => {
              $scope.model.loading = false;
              $scope.model.currentRequest = null;
            });
          }, 300),

        };

        this.$onInit = function() {
          $scope.model.locked = self.searchFilter.isKeyLocked();
        };

        $scope.$on('social-search-bar:clear', () => {
          const currentSearchFilterValue = self.searchFilter.getValue();
          if (currentSearchFilterValue && !!currentSearchFilterValue.length) {
            self.searchFilter.setValues([]);
          }
        });
      },
    ],
  });
})();
